import styled from "styled-components";

export const MainLayout = styled.div`
  max-width: 1100px;
  margin: 0 auto;
  padding-left: 50px;
  padding-right: 50px;
`;
